module.exports = __webpack_public_path__ + "static/img/A_pikes.48ae53d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/A_pikes.svg
// module id = 1IvC
// module chunks = 1